import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

interface ClinicalTrialActionsProps {
  onWaitingList: () => void;
}

const ClinicalTrialActions = ({ onWaitingList }: ClinicalTrialActionsProps) => {
  return (
    <div className='space-y-3'>
      <button
        type='button'
        onClick={onWaitingList}
        className='btn btn-primary w-full h-14 text-base font-semibold shadow-primary hover:shadow-medium transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]'
      >
        <NotificationsNoneIcon className='!w-4 !h-4 mr-2' />
        나에게 맞는 임상시험 소식 받기
      </button>

      <p className='text-center text-xs text-muted-foreground/70'>
        임상시험 참여는 자발적이며, 언제든지 철회할 수 있습니다.
      </p>
    </div>
  );
};

export default ClinicalTrialActions;
